import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { CircleProgressBar } from '@/bundle/shared/components/CircleProgressBar/CircleProgressBar';
import RightArrowIcon from '@/images/RightArrowIcon.svg?react';
import { ReactNode } from 'react';

type AdminOnboardingCircleStepBarType = {
  count: number;
  totalCount: number;
  currentStep: ReactNode;
  nextStep?: ReactNode;
};

export const AdminOnboardingCircleStepBar = ({
  count,
  totalCount,
  nextStep,
  currentStep,
}: AdminOnboardingCircleStepBarType) => {
  return (
    <Box width='100%' display='flex' flexDirection='row' alignItems='center' justifyContent='space-between'>
      <Box display='flex' flexDirection='column' rowGap='4px'>
        <Box display='flex' flexDirection='row' alignItems='center' columnGap='4px'>
          <RightArrowIcon />
          <Typography color={COLORS.grey[700]} fontWeight='semibold'>
            {currentStep}
          </Typography>
        </Box>
        {nextStep && (
          <Typography
            display='flex'
            alignItems='center'
            columnGap='4px'
            variant='caption'
            color={COLORS.grey[600]}
            fontWeight='medium'
          >
            Next: {nextStep}
          </Typography>
        )}
      </Box>
      <CircleProgressBar count={count} totalCount={totalCount} />
    </Box>
  );
};
